import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import CMSMarketplaceSettingsComponent from './cms-marketplace-settings.component';
import CMSLogisticsSettingsComponent from './cms-logistics-settings.component';

export const CMSComponent = ({ handleInnerFormChange, selectCMSSettings, handleFormSubmit }: any) => {

  const tabItems=[
    {
        id:1,
        title:'Marketplace Settings',
        component:<CMSMarketplaceSettingsComponent
        selectCMSSettings={selectCMSSettings} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    },
    {
        id:2,
        title:'Logistics Settings',
        component:<CMSLogisticsSettingsComponent
        selectCMSSettings={selectCMSSettings} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    }
  ]
  
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
    <TabContainer tabItems={tabItems} />
 
      <div className='flex w-full justify-end items-end'>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
            type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default CMSComponent;
